import { useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg, useApi } from "../lib/api";
import { ROLE_HOME } from "../context/AuthContext";
import { DgcEmblem } from "../components/Logo";

export default function Invite() {
  const { token } = useParams();
  const { data: inv, error } = useApi(`/public/invites/${token}`);
  const [f, setF] = useState({ email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const r = await api.post(`/public/invites/${token}/accept`, f);
      localStorage.setItem("dgc_token", r.data.token);
      window.location.href = ROLE_HOME[r.data.user.role];
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F8F5]" data-testid="invite-page">
      <div className="panel p-8 w-full max-w-md">
        <DgcEmblem size={64} />
        {error && <p className="mt-6 text-sm text-red-500" data-testid="invite-error">{error}</p>}
        {inv && (
          <form onSubmit={submit} className="mt-6 grid gap-3" data-testid="invite-accept-form">
            <div className="eyebrow">Private invitation from {inv.invited_by}</div>
            <h1 className="font-display text-3xl text-ink">Welcome, {inv.name}</h1>
            <p className="text-sm text-ink-3 mb-2">{inv.role === "secretary" ? "You've been invited to manage the partners' schedule and reminders." : "You've been invited to the family's private circle for photos and videos."} Create your access below.</p>
            <input required type="email" className="field" placeholder="Your email" value={f.email} onChange={set("email")} data-testid="invite-email" />
            <input required className="field" placeholder="Phone number" value={f.phone} onChange={set("phone")} data-testid="invite-phone" />
            <input required type="password" minLength={8} className="field" placeholder="Create a password (8+ characters)" value={f.password} onChange={set("password")} data-testid="invite-password" />
            {err && <p className="text-sm text-red-500" data-testid="invite-accept-error">{err}</p>}
            <button disabled={busy} className="btn-gold" data-testid="invite-accept-btn">{busy ? "Creating…" : "Create my access"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
